import _extends from "@babel/runtime/helpers/esm/extends";
import parse from '../utils/propParser';

var Component = function Component(props) {
  var _this = this;

  this.toString = function () {
    return parse(_extends({}, _this, {
      toString: undefined
    }));
  };

  Object.entries(props).forEach(function (_ref) {
    var key = _ref[0],
        value = _ref[1];
    _this[key] = value;
  });
};

export { Component as default };